import Button from "@material-ui/core/Button";
import Progress from "@material-ui/core/CircularProgress";
import Paper from "@material-ui/core/Paper";
import { createStyles, Theme, withStyles, WithStyles } from "@material-ui/core/styles";
import classnames from "classnames";
import React, { useState, useContext } from "react";
import { Field, Form, FormSpy } from "react-final-form";
import { Select } from "../components/Select";
import { TextField } from "../components/TextField";
import { login, resetPassword as apiResetPassword } from "../lib/api/base";
import { history } from "../lib/history";
import Insights from "./Insights.png";
import AssetXLarge from "./Asset-min.png";
import AssetMedium from "./Asset720.png";
import AssetLarge from "./Asset1080.png";
import { LoginPortal } from "../portals/Login";
import { UserContext } from "../contexts/UserContext";
import { Route } from "react-router";
import { CriteriaContext } from "../contexts/CriteriaContext";
import { FormattedMessage, useIntl } from "react-intl";
import { LanguageContext } from "../contexts/LanguageContext";
import { createMuiTheme, MuiThemeProvider, Snackbar, Typography } from "@material-ui/core";
import Close from "@material-ui/icons/Close";

export const theme = createMuiTheme({
  overrides: {
    MuiFilledInput: {
      root: {
        borderTopRightRadius: "0",
        borderTopLeftRadius: "0",
      },
      input: {
        padding: "16px 12px",
      },
      underline: {
        "&:after": {
          borderBottom: "2px solid #E6134B",
        },
      },
    },
    MuiInputBase: {
      root: {
        color: "#ffffff",
      },
      input: {
        width: "190px",
        position: "relative",
        top: "-4px",
        borderRadius: "0",
        background: "#50505B",
        padding: "7px 10px 7px 10px",
        color: "#ffffff",
        fontSize: "14px",
        fontFamily:
          "'Montserrat', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen-Sans, Ubuntu, Cantarell, 'Helvetica Neue', Helvetica, Arial, sans-serif",
        // minWidth: "250px",
        // display: "flex",
        // flex: 1,
      },
      inputType: {
        height: "100%",
      },
    },
    MuiGrid: {
      item: {
        paddingTop: "8px",
      },
    },
    MuiInput: {
      input: {
        background: "#50505B",
        "&:-webkit-autofill": {
          transition: "background-color 5000s ease-in-out 0s",
          "-webkit-text-fill-color": "#ffffff",
        },
      },
    },
    MuiInputLabel: {
      formControl: {
        position: "absolute",
        top: "-8px",
        background: "transparent",
      },
    },
    MuiFormControl: {
      root: {
        // marginBottom: "1rem",
        // minWidth: "230px",
      },
    },
    MuiFormLabel: {
      root: {
        cursor: "pointer",
        position: "relative",
        zIndex: 11111111,
        display: "flex",
        alignContent: "center",
        paddingTop: "10px",
        color: "#ffffff",
        fontSize: "14px",
        fontFamily:
          "'Montserrat', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen-Sans, Ubuntu, Cantarell, 'Helvetica Neue', Helvetica, Arial, sans-serif",
      },
      focused: {
        fontWeight: "bold",
        color: "#E6134B",
      },
    },
    MuiFormHelperText: {
      root: {
        marginTop: "8px",
      },
    },
    MuiButton: {
      root: {
        minWidth: "200px",
        fontSize: 15,
        textTransform: "none",
        borderRadius: 30,
      },
      contained: {
        boxShadow: "0",
      },
      containedPrimary: {
        backgroundColor: "#E6134B",
        marginTop: "1rem",
        "&:hover": {
          backgroundColor: "#8A0D2F",
        },
      },
      label: {
        color: "#ffffff",
      },
    },
  },
});

const styles = (theme: Theme) =>
  createStyles({
    container: {
      display: "flex",
      justifyContent: "center",
      alignContent: "center",
      height: "100vh",
      width: "100%",
      background: `url(${AssetMedium})`,
      backgroundRepeat: "no-repeat",
      backgroundSize: "cover",
      backgroundPosition: "center bottom",
      ["@media (min-width:720px)"]: {
        background: `url(${AssetLarge})`,
        backgroundRepeat: "no-repeat",
        backgroundSize: "cover",
        backgroundPosition: "center bottom",
      },
      ["@media (min-width:1200px)"]: {
        background: `url(${AssetXLarge})`,
        backgroundRepeat: "no-repeat",
        backgroundSize: "cover",
        backgroundPosition: "center bottom",
      },
    },
    img: {
      height: "100vh",
      width: "100vw",
    },
    root: {
      margin: "auto",
      display: "flex",
      flexDirection: "column",
      width: 350,
      height: 450,
      backgroundColor: "#eeeeee",
      alignItems: "center",
      justifyContent: "center",
      ["@media (max-width:700px)"]: {
        width: "100%",
      },
      border: "none",
      borderRadius: 5,
    },
    buttons: {
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      width: "100%",
      gap: "5px",
    },
    form: {
      width: "76%",
      display: "flex",
      flexDirection: "column",
      justifyContent: "space-between",
    },
    inputGrid: {
      height: "50px",
      width: "100%",
      backgroundColor: "#50505B",
      display: "flex",
      justifyContent: "center",
      marginBottom: theme.spacing.unit * 2,
      padding: `${theme.spacing.unit / 2}px ${theme.spacing.unit + 2}px`,
    },
    inputAdornment: {
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      color: "#ffffff",
      transform: "translateY(2px)",
    },
    inputs: {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      flexDirection: "column",
      gap: "10px",
      marginTop: theme.spacing.unit * 3,
      marginBottom: theme.spacing.unit * 3,
      "& select": { width: "100%" },
    },
    logo: {
      width: 150,
    },
    input: {
      borderRadius: "0",
      marginTop: theme.spacing.unit,
      marginBottom: theme.spacing.unit,
    },
    backgroundInput: {
      "&:-webkit-autofill": {
        background: "red",
        border: "2px solid orange",
      },
    },
    languageSelect: {
      padding: "0",
      cursor: "pointer",
      marginTop: "1em",
      minWidth: "110px",
      flex: "0 0 auto",
      fontSize: "14px",
      height: "auto",
      color: "#333",
      position: "fixed",
      fontFamily:
        "'Montserrat', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen-Sans, Ubuntu, Cantarell, 'Helvetica Neue', Helvetica, Arial, sans-serif",
      "& :nth-child(1), :nth-child(2)": {
        backgroundColor: "#eeeeee",
        color: "#181818",
      },
    },
    languageContainer: {
      marginTop: "1rem",
      display: "grid",
      gridTemplateColumns: "repeat(2, 1fr)",
      gap: "1rem",
      justifyContent: "space-between",
    },
    error: {
      backgroundColor: "#eee",
      border: "none",
      width: "100%",
      display: "flex",
      justifyContent: "center",
    },
    errorText: {
      color: "red",
      fontSize: "0.8rem",
    },
    resetButonSpacing: {
      marginTop: "35px",
    },
  });

export type LoginProps = {} & WithStyles<typeof styles>;

export const marketsFromSubdomain = {
  meaqa: "af",
  aseanqa: "as",
  australiaqa: "au",
  chinaqa: "cn",
  indiaqa: "in",
  newzealandqa: "nz",
  southafricaqa: "za",
  masterqa: "ma",
  meastaging: "s7",
  aseanstaging: "s1",
  australiastaging: "s4",
  chinastaging: "s3",
  indiastaging: "s5",
  newzealandstaging: "s6",
  southafricastaging: "s2",
  masterstaging: "s8",
  mea: "af",
  asean: "as",
  australia: "au",
  china: "cn",
  india: "in",
  newzealand: "nz",
  southafrica: "za",
  master: "ma",
  mea4: "af",
  asean4: "as",
  australia4: "au",
  china4: "cn",
  india4: "in",
  newzealand4: "nz",
  southafrica4: "za",
  master4: "ma",
};

const setError = ([fieldName, error], state) => {
  if (error !== undefined) {
    state.formState.errors[fieldName] = error;
  } else {
    delete state.formState.errors[fieldName];
  }
  state.fields.email.touched = true;
};

const announcementdata = {
  asean: {
    support: "insightbmteam@msxi.com",
    url: "https://asean.msxinsightbm.com/",
  },
  southafrica: {
    support: "insightbmteamsa@msxi.com",
    url: "https://southafrica.msxinsightbm.com/",
  },
  china: {
    support: "insightbmteamcn@msxi.com",
    url: "https://china.msxinsightbm.com/",
  },
  india: {
    support: "insightbmteamin@msxi.com",
    url: "https://india.msxinsightbm.com/",
  },
  australia: {
    support: "insightbmteamau@msxi.com",
    url: "https://australia.msxinsightbm.com/",
  },
  newzealand: {
    support: "insightbmteamnz@msxi.com",
    url: "https://newzealand.msxinsightbm.com/",
  },
};

const LoginUnstlyed: React.FunctionComponent<LoginProps> = ({ classes, children }) => {
  const [loggedIn, setLoggedIn] = useState(false);
  const [credentials, setCredentials] = useState<{ email: string; password: string }>({ email: "", password: "" });
  const { criteria, hydrate: hydrateCriteria, loading: loadingCriteria } = useContext(CriteriaContext);
  const { user, hydrate, loading } = useContext(UserContext);
  const { language, updateUserLanguage, languageOptions, updateLanguageConfig } = useContext(LanguageContext);
  const intl = useIntl();
  const [requireActivation, setRequireActivation] = useState<boolean>(false);
  const [showPassword, setShowPassword] = useState<boolean>(false);
  const [uName, setUsername] = useState<string>("");
  const [market, setMarket] = useState<string>("");
  const [resettingPassword, setResettingPassword] = useState<boolean>(false);
  const [errorMessage, setErrorMessage] = useState<string>("");

  const resetPassword = async (form: any) => {
    const result = await apiResetPassword(uName, market);
    form.mutators.setError("email", result.message);
    setResettingPassword(false);
  };

  if (loggedIn && loading.loaded && loadingCriteria.loaded) {
    return (
      <LoginPortal>
        <MuiThemeProvider theme={theme}>
          <form
            method="POST"
            target="federated-login"
            action={user.modules.login}
            ref={ref => {
              ref && ref.submit();
            }}
          >
            <input type="text" name="username" value={credentials.email} />
            <input type="password" name="password" value={credentials.password} />
            <button>Login</button>
          </form>
          <iframe
            name="federated-login"
            title="federated-login"
            data-test-id="federated login iframe"
            onLoad={() => {
              if (criteria.oems.length >= 2) {
                history.push("/filters");
              } else {
                history.push("/dashboard");
              }
            }}
          />
        </MuiThemeProvider>
      </LoginPortal>
    );
  }

  return (
    <div className={classes.container}>
      <Paper className={classnames(classes.root)}>
        <Route
          path="/login"
          render={({ match }) => (
            <Form
              initialValues={{ market: marketsFromSubdomain[window.location.host.split(".")[0].split("-")[0]] }}
              onSubmit={async (fields: any) => {
                try {
                  setErrorMessage("");
                  const user = await login(fields);
                  if (user.message == "You need to provide an activation token") {
                    setRequireActivation(true);
                    setErrorMessage(intl.formatMessage({ id: "login.page.require.activation" }));
                    return {
                      email: "",
                      password: "",
                    };
                  }
                  if (user.message == "Activation token still valid") {
                    setRequireActivation(true);
                    return {
                      activationcode: intl.formatMessage({ id: "login.page.require.activation_still_valid" }),
                    };
                  }
                  if (user.message == "Invalid credentials") {
                    setErrorMessage(intl.formatMessage({ id: "login.page.login.error" }));
                    return {
                      email: "",
                      password: "",
                    };
                  }
                  if (user.message == "Account Locked. Please Contact Support.") {
                    setErrorMessage(intl.formatMessage({ id: "login.page.lockedout" }));
                    return {
                      email: "",
                      password: "",
                    };
                  }
                  if (user.message == "You have not logged on for a long time, as a result your account has been locked.") {
                    setErrorMessage(intl.formatMessage({ id: "login.page.lockedout.aged" }));
                    return {
                      email: "",
                      password: "",
                    };
                  }
                  if (user.message == "Activation token is invalid. A new token has been emailed to you.") {
                    setErrorMessage(intl.formatMessage({ id: "login.page.invalid.activation.code" }));
                    return {
                      email: "",
                      password: "",
                    };
                  }
                  if (user.message) {
                    throw Promise.reject("Failure to login");
                  }
                  await Promise.all([hydrateCriteria(), hydrate()]);
                  await updateLanguageConfig(language);
                  setCredentials(fields);
                  setLoggedIn(true);
                } catch (e) {
                  setErrorMessage(intl.formatMessage({ id: "login.page.general.error" }));
                }
              }}
              mutators={{ setError }}
              render={({ form, values, dirty, touched, handleSubmit, submitting }) => (
                <>
                  <form onSubmit={handleSubmit} className={classes.form}>
                    <FormSpy
                      onChange={props => {
                        setUsername(props.values.email);
                        setMarket(props.values.market);
                      }}
                    />
                    <div className={classes.buttons}>
                      <img className={classes.logo} src={Insights} />
                    </div>
                    <div className={classes.inputs}>
                      {(dirty ? touched.market : !values.market) && (
                        <Field className={classes.input} name="market" label="Market" component="select">
                          <option value="">Select a market</option>
                          <option value="af">Middle East & Africa</option>
                          <option value="as">Asean"</option>
                          <option value="au">Australia</option>
                          <option value="cn">China</option>
                          <option value="in">India</option>
                          <option value="nz">New Zealand</option>
                          <option value="za">South Africa</option>
                          <option value="ma">Master</option>
                        </Field>
                      )}
                      {!requireActivation && (
                        <Field className={classes.input} name="email" label={<FormattedMessage id="login.page.username.label" />} component={TextField} />
                      )}
                      {!requireActivation && (
                        <Field
                          className={classes.input}
                          name="password"
                          label={<FormattedMessage id="login.page.password.label" />}
                          type="password"
                          component={TextField}
                        />
                      )}
                      {requireActivation && (
                        <Field
                          className={classes.input}
                          name="activationcode"
                          label={<FormattedMessage id="login.page.activation.code.label" />}
                          component={TextField}
                        />
                      )}
                      <Paper hidden={errorMessage.length == 0} className={classes.error}>
                        <Typography className={classes.errorText}>{errorMessage}</Typography>
                      </Paper>
                      <div style={{ position: "fixed", top: "0", right: "14px" }}>
                        <Select
                          name="language"
                          className={classnames(classes.languageSelect)}
                          placeholder="Language"
                          value={languageOptions.find(lang => lang.value === language)}
                          onChange={(language: { value: string; label: string }) => updateUserLanguage(language.value)}
                          options={languageOptions}
                        />
                      </div>
                    </div>
                    <div className={classes.buttons}>
                      <Button
                        disabled={submitting || loggedIn || resettingPassword}
                        variant="contained"
                        color="primary"
                        type="submit"
                        style={{ width: "100%", height: "35px" }}
                      >
                        {(submitting || loggedIn) && <Progress size={12} />}
                        <FormattedMessage id="login.page.login.button" />
                      </Button>
                      <Button
                        className={classes.resetButonSpacing}
                        disabled={submitting || loggedIn || resettingPassword}
                        variant="text"
                        color="default"
                        style={{ color: "#a8a8a8" }}
                        onClick={() => {
                          if (!!uName) {
                            setResettingPassword(true);
                            resetPassword(form);
                          } else {
                            form.mutators.setError("email", "Cant be blank. Please enter your username to reset your password");
                          }
                        }}
                      >
                        {resettingPassword && <Progress size={12} />}
                        <FormattedMessage id="login.page.reset.password.button" />
                      </Button>
                    </div>
                  </form>
                </>
              )}
            />
          )}
        />
      </Paper>
    </div>
  );
};

export const Login = withStyles(styles)(LoginUnstlyed);

export default Login;
